var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongArrowRight = function SvgLongArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.212 6.525 37.262.612c-.412-.48-1.168-.55-1.718-.137-.482.412-.55 1.169-.138 1.719L40.15 7.9H10.244c-.55-2.063-2.407-3.575-4.607-3.575A4.753 4.753 0 0 0 .894 9.069a4.753 4.753 0 0 0 4.743 4.743c2.2 0 4.057-1.512 4.607-3.574h29.975l-4.813 5.637c-.412.481-.344 1.238.138 1.719.206.206.48.275.756.275.344 0 .687-.138.894-.413l4.95-5.912c1.306-1.513 1.306-3.575.068-5.019ZM5.637 11.338A2.318 2.318 0 0 1 3.3 9a2.318 2.318 0 0 1 2.337-2.338A2.318 2.318 0 0 1 7.975 9a2.318 2.318 0 0 1-2.338 2.338Z",
    fill: "currentColor"
  })));
};
export default SvgLongArrowRight;